import { ClassTypeOptions, ra, ra_property } from '@cundd/rest-adapter';
import { Contact } from './Contact';
import { Department } from './Department';
import { Industry } from './Industry';
import { JobCenterModelInterface } from './JobCenterModelInterface';
import { Sector } from './Sector';

@ra(ClassTypeOptions.AddUnknownFields)
export class JobVacancy implements JobCenterModelInterface {
    @ra_property()
    public referenceId: string = '';

    @ra_property()
    public title: string = '';

    @ra_property(Date)
    public creationDate?: Date;

    @ra_property()
    public description = '';

    @ra_property()
    public requirements = '';

    @ra_property()
    public requiredLanguages = '';

    @ra_property()
    public additionalInformation = '';

    @ra_property()
    public highlight: boolean = false;

    @ra_property()
    public uri: string = '';

    @ra_property()
    public employmentType: string = '';

    @ra_property()
    public jobStartDate: string = '';

    @ra_property()
    public workloadFrom: string = '';

    @ra_property()
    public workloadTo: string = '';

    @ra_property()
    public contextLanguage: string = '';

    @ra_property(Department)
    public department?: Department;

    @ra_property(Industry)
    public industry?: Industry;

    @ra_property(Sector)
    public sector?: Sector;

    @ra_property(Contact)
    public applicationContact?: Contact;

    @ra_property('location')
    private _location = '';

    get location(): string {
        if (this._location) {
            return this._location;
        }
        const lines = this.additionalInformation.split('\n');
        if (lines.length === 0) {
            return '';
        }
        if (lines[0].substr(0, 12).toLowerCase() === 'arbeitsort: ') {
            return lines[0].substr(12);
        } else {
            return '';
        }
    }

    get additionalInformationWoLocation(): string[] {
        const lines = this.additionalInformation.split('\n');
        if (lines.length === 0) {
            return [];
        }
        if (lines[0].substr(0, 12).toLowerCase() === 'arbeitsort: ') {
            return lines.splice(1);
        } else {
            return [];
        }
    }

    public getPaginationItemKey(): string {
        return this.referenceId;
    }
}
